import { Form, Input, Select, Button, Card, Spin, DatePicker } from "antd";
import { UserService } from "../../services/user/UserService";
import React, { Component } from "react";
import { showSuccessToast } from "../general/ToastHelper";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { withRouter } from "react-router-dom";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import "./User.css";
import "./CreateUser.css";
import { Translation } from "react-i18next";
import i18next from "i18next";
import queryString from "query-string";
import { Constants } from "../../data/constants";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import ar from "antd/es/date-picker/locale/ar_EG";
import en from "antd/es/date-picker/locale/en_US";
dayjs.extend(customParseFormat);
class CreateAccountAdminForm extends Component {
  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("createAdminAccount");

    this.constants = new Constants();
    this.state = {
      confirmDirty: false,
      user: {},
      isFetching: false,
      formLayout: "inline",
      prefix: this.constants.PREFIX_NUM,
      lang:
        this.props.context.curr_lang === "ar" &&
        this.props.context.curr_dir === "rtl"
          ? "ar"
          : "en",
    };
  }

  componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    const user = {};
    user["accountId"] = this.props.match.params.id;
    user["userEmail"] = values["email"] ? values["email"] : "";
    user["userFullname"] = values["name"] ? values["name"] : "";
    user["userNumber"] = values["number"] ? values["number"] : "";
    this.setState({
      user: user,
    });
  }

  handleDropdownChange(value) {
    let { user } = this.state;
    user.userType = value;
    this.setState({ user });
  }
  handleConfirm = (e) => {
    let { accountId } = this.state.user;
    e.preventDefault();
    let history = this.props.history;

    this.props.form.validateFields(async (err, values) => {
      try {
        if (!err) {
          this.setState({ loading: true });
          this.userService = new UserService();
          const selectedDate = values["userBirthdate"]
            .format("YYYY")
            .toString()
            .split("T")[0];
          const todaysDate = dayjs()
            .endOf("day")
            .format("YYYY")
            .toString()
            .split("T")[0];
          if (todaysDate - selectedDate >= 18) {
            values["userBirthdate"] = values["userBirthdate"]
              .format()
              .toString()
              .split("T")[0];
          } else {
            throw new Error(i18next.t("user age must be at least 18"));
          }
          values["userNumber"] = values["userNumber"];
          values["accountId"] = accountId;
          values["createAdminFlag"] = true;

          let data = await this.userService.createUser(
            this.props.context.session_id,
            values,
            this.constants.accountServicesURLs.postAccountAdmin
          );

          showSuccessToast(i18next.t(data.statusMsg));
          this.setState({ loading: false });
          this.props.form.resetFields();
          history.push("/home/accounts");
        }
      } catch (e) {
        this.setState({ loading: false, visible: false });
        handleError(e);
      }
    });
  };
  handlePrefixSelector(e) {
    let value = e;
    this.setState({ prefix: value });
  }
  handleConfirmBlur = (e) => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue("userPassword")) {
      callback("Two passwords that you enter is inconsistent!");
    } else {
      callback();
    }
  };

  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty) {
      form.validateFields(["confirm"], { force: true });
    }
    callback();
  };
  onFocus = (event) => {
    if (event.target.autocomplete) {
      event.target.autocomplete = "whatever";
    }
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    const { Option } = Select;
    let { isFetching } = this.state;
    const prefixSelector = getFieldDecorator("prefix", {
      initialValue: this.constants.PREFIX_NUM,
    })(
      <Select
        style={{ width: 70 }}
        onChange={(e) => this.handlePrefixSelector(e)}
      >
        <Option value="010">010</Option>
        <Option value="011">011</Option>
        <Option value="012">012</Option>
        <Option value="015">015</Option>
      </Select>
    );
    const disabledDate = (current) => {
      // Can not select days after today
      return current > dayjs().endOf("day");
    };
    return (
      <Translation>
        {(t) => (
          <Page title={t("Create Account Admin")} hasBackArrow={true}>
            {isFetching ? (
              <Spin></Spin>
            ) : (
              <Card
                style={{
                  marginTop: "10px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                }}
                bordered={false}
              >
                <Form className="form-style" {...formItemLayout}>
                  <Form.Item label={t("User Email")} {...formItemLayout}>
                    {getFieldDecorator("userEmail", {
                      initialValue: this.state.user.userEmail,

                      rules: [
                        {
                          type: "email",
                          message: t("The input is not valid E-mail!"),
                          required: true,
                        },
                      ],
                    })(<Input />)}
                  </Form.Item>

                  <Form.Item label={t("User Full Name")} {...formItemLayout}>
                    {getFieldDecorator("userFullname", {
                      initialValue: this.state.user.userFullname,
                      rules: [
                        {
                          type: "string",
                          message: t("The input is not valid "),
                        },
                        {
                          required: true,
                          message: t("Please enter user full name"),
                        },
                      ],
                    })(<Input />)}
                  </Form.Item>

                  <Form.Item label={t("User Birthdate")} {...formItemLayout}>
                    {getFieldDecorator("userBirthdate", {
                      initialValue: this.state.user.userBirthdate,
                      rules: [
                        {
                          required: true,
                          message: t("Please enter user birthdate"),
                        },
                      ],
                    })(
                      <DatePicker
                        disabledDate={disabledDate}
                        locale={this.state.lang === "ar" ? ar : en}
                        allowClear={false}
                      />
                    )}
                  </Form.Item>

                  <Form.Item label={t("User Gender")} {...formItemLayout}>
                    {getFieldDecorator("userGender", {
                      initialValue: "M",

                      rules: [
                        {
                          required: true,
                          message: t("Please select user gender"),
                        },
                      ],
                    })(
                      <Select
                        placeholder={t("Select ")}
                        onChange={this.handleSelectChange}
                      >
                        <Option value="M">{t("Male")}</Option>
                        <Option value="F">{t("Female")}</Option>
                      </Select>
                    )}
                  </Form.Item>

                  <Form.Item label={t("User Name")} {...formItemLayout}>
                    {getFieldDecorator("userName", {
                      initialValue: this.state.user.userName,
                      rules: [
                        {
                          type: "string",
                          message: t("The input is not valid "),
                        },
                        {
                          required: true,
                          message: t("Please enter user name"),
                        },
                      ],
                    })(<Input autoComplete="off" onFocus={this.onFocus} />)}
                  </Form.Item>

                  <Form.Item label={t("User Number")} {...formItemLayout}>
                    {getFieldDecorator("userNumber", {
                      initialValue: this.state.user.userNumber,
                      rules: [
                        {
                          type: "string",
                          message: t("The input is not valid "),
                          pattern: "^([2][0][1])(?:[0]|[1]|[2]|[5])[0-9]*$",
                        },
                        {
                          required: true,
                          message: t("Please enter user number"),
                        },
                      ],
                    })(<Input maxLength={12} />)}
                  </Form.Item>

                  {/* <Form.Item
                name="userPassword"
                label="User Password"
                {...formItemLayout}
                hasFeedback
              >
                {getFieldDecorator("userPassword", {
                  initialValue: this.state.user.userPassword,
                  rules: [
                    {
                      required: true,
                      message: "Please enter user password",
                    },
                    {
                      validator: this.validateToNextPassword,
                    },
                  ],
                })(
                  <Input.Password autoComplete="off" onFocus={this.onFocus} />
                )}
              </Form.Item>

              <Form.Item label="Confirm Password" hasFeedback>
                {getFieldDecorator("confirm", {
                  rules: [
                    {
                      required: true,
                      message: "Please confirm your password!",
                    },
                    {
                      validator: this.compareToFirstPassword,
                    },
                  ],
                })(
                  <Input.Password
                    onBlur={this.handleConfirmBlur}
                    autoComplete="off"
                    onFocus={this.onFocus}
                  />
                )}
              </Form.Item> */}

                  <Form.Item label={t("User Type")} {...formItemLayout}>
                    {getFieldDecorator("userType", {
                      initialValue: "ADMIN",

                      rules: [
                        {
                          message: t("Please enter Account  Category"),
                        },
                      ],
                    })(
                      <Select
                        onChange={(value) => this.handleDropdownChange(value)}
                      >
                        <Option value="ADMIN">Admin</Option>
                      </Select>
                    )}
                  </Form.Item>

                  <Form.Item
                    wrapperCol={{
                      xs: { span: 24, offset: 0 },
                      sm: { span: 16, offset: 8 },
                    }}
                  >
                    <Button
                      className="button-submit"
                      type="primary"
                      onClick={this.handleConfirm}
                      size={"small"}
                      loading={this.state.loading}
                    >
                      {t("Submit")}
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            )}
          </Page>
        )}
      </Translation>
    );
  }
}
export default Form.create()(
  withSharedStateConsumer(withRouter(CreateAccountAdminForm))
);
